import { h, t, T, domWithScope } from '@jsx6/jsx6'

export const areaEndInvite = (chat) => {
  return (
    <div p="area.endInvite" hidden>
      <div class="end-message">
        <span>{T`invite_end_message`}</span>
        <br />
        <span>{T`invite_end_message2`}</span>
      </div>
      {chat.$s.logo}
    </div>
  )
}
